import { render, staticRenderFns } from "./NextGame.vue?vue&type=template&id=6e0e09eb&scoped=true&"
import script from "./NextGame.vue?vue&type=script&lang=js&"
export * from "./NextGame.vue?vue&type=script&lang=js&"
import style0 from "./NextGame.vue?vue&type=style&index=0&id=6e0e09eb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0e09eb",
  null
  
)

export default component.exports